import React from 'react';
import { Container, Row } from 'react-bootstrap';
import styled from 'styled-components';

import Topbar from 'province-app/comps/Topbar';
import HomeTabs from 'province-app/comps/HomeTabs';

const Holder = styled(Container)`
    background-color: #535559;
`;

const HomePage = () => {
    return (
        <Holder fluid>
            <Row>
                <Topbar />
            </Row>
            <Row>
                <HomeTabs />
            </Row>
        </Holder>
    );
};

export default HomePage;